import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  TaxCode, TaxCodeLookup, TaxCodeSave, TaxDefaultsResult, TaxPaymentRequest, TaxProfile, TaxReturn, TaxSettlement,
} from '../interfaces/indirectTax.interface';

const T = ENDPOINTS.INDIRECT_TAX;

export const IndirectTaxService = {
  getProfile: async (institutionId: string): Promise<TaxProfile> => (await axios.get(T.PROFILE(institutionId))).data,
  saveProfile: async (dto: TaxProfile): Promise<TaxProfile> => (await axios.put(T.PROFILE_SAVE, dto)).data,
  getCodes: async (institutionId: string): Promise<TaxCode[]> => (await axios.get(T.CODES(institutionId))).data,
  createCode: async (dto: TaxCodeSave): Promise<TaxCode> => (await axios.post(T.CODES_SAVE, dto)).data,
  updateCode: async (id: string, dto: TaxCodeSave): Promise<TaxCode> => (await axios.put(T.CODE(id), dto)).data,
  setCodeActive: async (id: string, active: boolean): Promise<TaxCode> => (await axios.put(T.CODE_ACTIVE(id, active))).data,
  deleteCode: async (id: string): Promise<void> => { await axios.delete(T.CODE(id)); },
  lookup: async (institutionId: string): Promise<TaxCodeLookup> => (await axios.get(T.LOOKUP(institutionId))).data,
  loadBangladeshDefaults: async (institutionId: string): Promise<TaxDefaultsResult> =>
    (await axios.post(T.LOAD_BD_DEFAULTS(institutionId))).data,
  getReturn: async (institutionId: string, date: string): Promise<TaxReturn> =>
    (await axios.get(T.RETURN(institutionId, date))).data,
  listSettlements: async (institutionId: string): Promise<TaxSettlement[]> =>
    (await axios.get(T.SETTLEMENTS(institutionId))).data,
  settle: async (institutionId: string, date: string): Promise<TaxSettlement> =>
    (await axios.post(T.SETTLE, { institutionId, date })).data,
  reopen: async (id: string): Promise<TaxSettlement> => (await axios.post(T.REOPEN(id))).data,
  recordPayment: async (dto: TaxPaymentRequest): Promise<TaxSettlement> => (await axios.post(T.PAY, dto)).data,
};
